<div
  class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
  <div class="flex-1 min-w-0">
    <div class="-ml-4">
      <a
        mat-button
        (click)="goBack()"
        [color]="'primary'">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-narrow-left'"></mat-icon>
        <span class="ml-2">Voltar</span>
      </a>
    </div>
    @if (party$ | async; as party) {
      <div class="mt-2">
        <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
          {{party.name}}
        </h2>
      </div>
    }
    <div class="flex flex-wrap items-center font-medium pt-2">
      <div class="flex items-center whitespace-nowrap">
        <a class="whitespace-nowrap text-primary-500 hover:underline cursor-pointer" (click)="goBack()" >
        {{pageTitle}}</a>
      </div>
      <div class="flex items-center whitespace-nowrap">
        <mat-icon
          class="icon-size-5"
          [svgIcon]="'chevron_right'">
        </mat-icon>
        <span class="ml-1 text-secondary">{{mode}}</span>
      </div>
    </div>
  </div>
</div>

